import React, { useState }from 'react';
import { Tooltip, Avatar } from 'antd';
import { colours } from './../utils/colours';

function CustomAvatar(props) {
  const [hasURL, setHasURL] = useState(true);

  const handleOnError = () => {
    setHasURL(false);
  }

  return (
    hasURL ?
    props.showTooltip ?
    <Tooltip title={props.tooltipTitle}>
      <Avatar style={props.style} size={props.size} src={props.src} onError={handleOnError} />
    </Tooltip>
    :
    <Avatar style={props.style} size={props.size} src={props.src} onError={handleOnError} />
    :
    props.showTooltip ?
    <Tooltip title={props.tooltipTitle}>
    <Avatar 
      style={{...{verticalAlign: 'middle', backgroundColor: colours[props.colourCode]}, ...props.style}} 
      size={props.size}
    >
      <span style={{fontSize: `${props.charSize}px`}}>{props.char}</span>
    </Avatar>
    </Tooltip>
    :
    <Avatar 
      style={{...{verticalAlign: 'middle', backgroundColor: colours[props.colourCode]}, ...props.style}} 
      size={props.size}
    >
      <span style={{fontSize: `${props.charSize}px`}}>{props.char}</span>
    </Avatar>
  );
}

export default CustomAvatar;
